import { render, staticRenderFns } from "./ErrorAlert.vue?vue&type=template&id=96015fb8&scoped=true&"
import script from "./ErrorAlert.vue?vue&type=script&lang=js&"
export * from "./ErrorAlert.vue?vue&type=script&lang=js&"
import style0 from "./ErrorAlert.vue?vue&type=style&index=0&id=96015fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96015fb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('96015fb8', component.options)
    } else {
      api.reload('96015fb8', component.options)
    }
    module.hot.accept("./ErrorAlert.vue?vue&type=template&id=96015fb8&scoped=true&", function () {
      api.rerender('96015fb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Alerts/ErrorAlert.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Alerts/ErrorAlert.vue
// module id = nM04
// module chunks = 0